(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero-custom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-hero-custom')) {
    customElements.define(
      'product-hero-custom',
      class ProductHeroCustom extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-variants]');
          this.variants = data ? JSON.parse(data.textContent) : [];
          this.vat = parseFloat(this.dataset.vat) || 1.25;

          const select = this.querySelector('[data-variant-select]');
          if (select) {
            select.addEventListener('change', () => this.onVariantChange(select.value));
          }

          const qty = this.querySelector('[data-qty-input]');
          const minus = this.querySelector('[data-qty-minus]');
          const plus = this.querySelector('[data-qty-plus]');
          if (qty && minus && plus) {
            minus.addEventListener('click', () => {
              qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
            });
            plus.addEventListener('click', () => {
              qty.value = (parseInt(qty.value, 10) || 1) + 1;
            });
          }

          this.querySelectorAll('[data-thumb]').forEach((thumb) => {
            thumb.addEventListener('click', () => {
              this.setImage(thumb.dataset.src);
              this.querySelectorAll('[data-thumb]').forEach((t) => t.removeAttribute('aria-current'));
              thumb.setAttribute('aria-current', 'true');
            });
          });
        }

        format(cents) {
          return Math.round(cents / 100).toLocaleString('da-DK') + ',-';
        }

        setImage(src) {
          const img = this.querySelector('[data-main-image]');
          if (img && src) img.src = src;
        }

        onVariantChange(id) {
          const variant = this.variants.find((item) => String(item.id) === String(id));
          if (!variant) return;

          this.querySelector('[data-price-ex]').textContent = this.format(variant.price);
          this.querySelector('[data-price-inkl]').textContent = this.format(variant.price * this.vat);

          const compare = this.querySelector('[data-price-compare]');
          if (compare) {
            const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
            compare.hidden = !onSale;
            if (onSale) compare.textContent = this.format(variant.compare_at_price);
          }

          const button = this.querySelector('[data-add-button]');
          if (button) {
            button.disabled = !variant.available;
            button.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
          }

          if (variant.featured_image && variant.featured_image.src) {
            this.setImage(variant.featured_image.src);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
